/** Max chars sent as playbook context (matches engine / agent limits). */
export const PLAYBOOK_CONTEXT_MAX_CHARS = 200_000;

export function buildPlaybookContextFromRows(
  projectName: string,
  rows: Array<{ paragraph_text: string; author: string; filename: string; side?: string }>,
): string {
  const header = `Project (playbook / past negotiations): ${projectName}\nTotal records: ${rows.length}\n\n`;
  const blocks: string[] = [];
  let i = 0;
  for (const r of rows) {
    i += 1;
    const author = r.author && r.author !== '—' ? r.author : '(unknown)';
    const sideLine =
      r.side === 'our_side'
        ? 'our_side'
        : r.side === 'their_side'
          ? 'their_side'
          : r.side || '';
    blocks.push(
      [
        `--- Record ${i} ---`,
        `Source file: ${r.filename}`,
        `Author: ${author}`,
        sideLine ? `Side: ${sideLine}` : null,
        '',
        r.paragraph_text.trim(),
        '',
      ]
        .filter((l) => l !== null)
        .join('\n'),
    );
  }
  let out = header + blocks.join('\n');
  if (out.length > PLAYBOOK_CONTEXT_MAX_CHARS) {
    out =
      out.slice(0, PLAYBOOK_CONTEXT_MAX_CHARS) +
      '\n\n[Truncated: playbook context exceeded size limit]';
  }
  return out;
}
